'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadImage = undefined;

var _client = require('../../utils/client');

var _images = require('../../utils/images');

var _params = require('../../utils/params');

var uploadImage = exports.uploadImage = function uploadImage() {
  var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return handleUploadImage(image).then(function (response) {
    return response.data.url;
  }).then(function (url) {
    return url && url.replace('http://', 'https://');
  });
};

var handleUploadImage = function handleUploadImage(image) {
  if (typeof image === 'string' && !(0, _images.isBase64EncodedUrl)(image)) {
    return _client.servicesAPI.post('/v1/justgiving/images', { image: image });
  }

  return _client.imagesAPI.post('/image', (0, _images.handleImageFile)(image), {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};